
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface CallbackActionsProps {
  status: 'processing' | 'success' | 'error';
  onRetry: () => void;
  onGoBack: () => void;
}

export const CallbackActions = ({ status, onRetry, onGoBack }: CallbackActionsProps) => {
  if (status === 'processing') {
    return (
      <div className="text-center text-sm text-gray-600">
        Aguarde enquanto configuramos sua integração...
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="space-y-3">
        <div className="text-center text-sm text-gray-600">
          Redirecionando para a página de integrações em alguns segundos...
        </div>
        <Button onClick={onGoBack} className="w-full">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar para Integrações
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <Button onClick={onRetry} variant="outline" className="w-full">
        Tentar Novamente
      </Button>
      <Button onClick={onGoBack} className="w-full">
        <ArrowLeft className="h-4 w-4 mr-2" />
        Voltar para Integrações
      </Button>
    </div>
  );
};
